import { defineMessages } from 'react-intl';

import { DefineMessages } from 'modules/I18n/types';

export const fileMessages: DefineMessages = defineMessages({
  fileRemove: { id: 'gofre.importer.Dropzone.file.remove' },
});
